/**
 * VNode helper
 */
export default {
  name: 'om-node',
  functional: true,
  props: {
    node: Array
  },
  render(h, ctx) {
    return ctx.props.node;
  }
};



// WEBPACK FOOTER //
// ./src/plugins/jscom/omui/components/utils/node.js